import Image from "./../image";
import { useNavigate } from "react-router-dom";
import SettingButton from "../button/setting-button";
import { useNavigationStore } from "./../../store/navigationStore";
import HomeLocationButton from "../button/home-location-button";
import ExplorationPanel from "../controls/exploration/exploration-panel";
import { useExplorationStore } from "@/store/explorationStore";
import ImageButton from "../button/image-button";
import { useState } from "react";
import CloseButton from "../button/close-button";
import WebCamera from "../camera/web-camera";

function homeHeader(onIconClicked: Function, onCameraClicked: Function) {
  return (
    <header className="flex items-center justify-between w-full px-4 py-3">
      <div className="flex items-center">
        <button onClick={() => onIconClicked()}>
          <Image
            src="/assets/logo.png"
            alt="dwm-logo"
            width={190}
            height={48}
          />
        </button>
        <div className="beta">
          <Image
            src="/assets/icon_beta.png"
            alt="beta icon"
            width={58}
            height={24}
          />
        </div>
      </div>
      <div className="flex items-center gap-8">
        <ImageButton
          aria-hidden
          src="/assets/icon_btn_camera.png"
          alt="icon"
          size={30}
          onClick={() => onCameraClicked()}
        />
        <HomeLocationButton />
        <SettingButton />
      </div>
    </header>
  );
}

export default function HomeLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const setVenueNotSupported = useNavigationStore(
    (state) => state.setVenueNotSupported
  );
  const setUserQuery = useNavigationStore((state) => state.setUserQuery);
  const setApiError = useNavigationStore((state) => state.setApiError);
  const [showCamera, setShowCamera] = useState(false);
  const clearChatHistory = useNavigationStore(state => state.clearChatHistory);

  let navigate = useNavigate();

  const homeIconClick = () => {
    setVenueNotSupported(false);
    setUserQuery("");
    setApiError("");
    clearChatHistory();
    navigate("/");
  };

  const ExplorationBottomPanel = () => {
    const showExplorationPanel = useExplorationStore(
      (state) => state.showExplorationPanel
    );

    return (
      <div
        className={`transition-alltransition-transform duration-700 ease-in-out h-[100dvh] fixed left-0 right-0 bottom-0
           ${showExplorationPanel ? "translate-y-0" : "translate-y-full"}`}
        style={{ zIndex: 54 }}
      >
        {showExplorationPanel && <ExplorationPanel />}
      </div>
    );
  };

  const QrCodeScanner = () => {
    const setStartPosition = useNavigationStore(
      (state) => state.setStartPosition
    );

    const handleScanFinish = (
      startVenueId: string,
      startMapId: string,
      startCoordinate: string,
      startPoi: string
    ) => {
      if (startVenueId && startMapId && startCoordinate && startPoi) {
        setStartPosition(
          startVenueId,
          startMapId,
          startCoordinate,
          startPoi
        );
        console.log("set start position");
        // TODO: add a toast or message to let user know scan completed
      }
      setShowCamera(false);
    };

    return (
      showCamera && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.8)",
            display: "flex",
            flexDirection: "column",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              padding: 20,
              justifyItems: "center",
            }}
          >
            <div className="absolute top-5 right-5 z-10">
              <CloseButton
                goBack={false}
                onClick={() => setShowCamera(false)}
              />
            </div>
            <WebCamera
              onScanFinish={(v: string, m: string, p: string, n: string) =>
                handleScanFinish(v, m, p, n)
              }
            />
          </div>
        </div>
      )
    );
  };

  return (
    <div
      className="landing min-h-screen flex flex-col"
      style={{ backgroundImage: 'url("/assets/bg_landing.jpg")' }}
    >
      {homeHeader(
        () => homeIconClick(),
        () => setShowCamera(true)
      )}
      {children}
      <ExplorationBottomPanel />
      <QrCodeScanner />
    </div>
  );
}
